<template>
<code>

&lt;html lang="en"><br>
&lt;head><br>

&lt;meta charset="UTF-8"><br>

&nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://swarm.video/swarm.js">&lt;/script><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script><br>

&nbsp;&nbsp;&nbsp;&nbsp;&lt;link rel="stylesheet" href="https://releases.flowplayer.org/7.2.7/skin/skin.css"><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://releases.flowplayer.org/7.2.7/flowplayer.min.js">&lt;/script><br>

&lt;style><br>
&nbsp;&nbsp;&nbsp;&nbsp;#video {<br>
&nbsp;&nbsp;&nbsp;&nbsp;width: 720px;<br>
&nbsp;&nbsp;&nbsp;&nbsp;margin-left: auto;<br>
&nbsp;&nbsp;&nbsp;&nbsp;margin-right: auto;<br>
&nbsp;&nbsp;&nbsp;&nbsp;display: block;<br>
&nbsp;&nbsp;&nbsp;&nbsp;}<br>
&lt;/style><br>

&lt;/head><br>

                              
                                                                
&lt;body><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;div id="video" class="fp-slim">&lt;/div><br>
&lt;/body><br>
&lt;script><br>

let engine = new p2pml.hlsjs.Engine({segments: {swarmId: "CustomSwarmId"},loader: {httpUseRanges:false, WaitForTracker: true, WaitForTrackerCounter:4500}}); <br>
let player = flowplayer("#video", {<br>
&nbsp;&nbsp;&nbsp;&nbsp;clip: {<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sources: [{<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;src: 'https://wowza.peer5.com/live/smil:bbb_abr.smil/playlist.m3u8',<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;type: "application/x-mpegurl"<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}]<br>
&nbsp;&nbsp;&nbsp;&nbsp;},<br>
&nbsp;&nbsp;&nbsp;&nbsp;hlsjs: {<br>
&nbsp;&nbsp;&nbsp;&nbsp;liveSyncDurationCount: 7,<br>
&nbsp;&nbsp;&nbsp;&nbsp;loader: engine.createLoaderClass(),<br>
&nbsp;&nbsp;&nbsp;&nbsp;safari: true }<br>});<br>
p2pml.hlsjs.initFlowplayerHlsJsPlayer(player);<br>
<br>
&lt;/script><br>
&lt;/html><br>
                            </code>
</template>

<script>
export default {
  name: "flowlayer",
 
  
};
</script>
